import { useEffect, useState } from "react";

type Size = { width: number; height: number };

export function useWindowSize(initial: Size = { width: 0, height: 0 }) {
  const [size, setSize] = useState<Size>(() => {
    if (typeof window === "undefined") return initial;
    return { width: window.innerWidth, height: window.innerHeight };
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}
